import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl, prettyPrintJson, isPremium, premiumMessage } from "../utils/config";

import Loader from "./layouts/Loader";

function Profile() {

    const { type } = useParams();
    const [state, setState] = useState(globalState.state);
    const [updatingProfile, setUpdatingProfile] = useState(false);
    const [pageType, setPageType] = useState(type ?? "profile");
    const [pageName, setPageName] = useState("");

    const [payments, setPayments] = useState([]);
    const [fetchingPayments, setFetchingPayments] = useState(false);
    const [paymentsPage, setPaymentsPage] = useState(1);
    const [paymentsPages, setPaymentsPages] = useState(0);
    const [refetchPayments, setRefetchPayments] = useState(0);

    const [receipts, setReceipts] = useState([]);
    const [fetchingReceipts, setFetchingReceipts] = useState(false);
    const [receiptsPage, setReceiptsPage] = useState(1);
    const [receiptsPages, setReceiptsPages] = useState(0);
    const [refetchReceipts, setRefetchReceipts] = useState(0);

    const [changingPassword, setChangingPassword] = useState(false);
    const [education, setEducation] = useState(state.user?.education || []);
    const [experiences, setExperiences] = useState(state.user?.experiences || []);
    const [certificates, setCertificates] = useState(state.user?.certificates || []);

    const [projects, setProjects] = useState([]);
    const [addingProject, setAddingProject] = useState(false);
    const [updatingProject, setUpdatingProject] = useState(false);
    const [deletingProject, setDeletingProject] = useState(false);
    const [hasFetchedProfile, setHasFetchedProfile] = useState(false);

    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [submittingPost, setSubmittingPost] = useState(false);
    const [postSelectedFiles, setPostSelectedFiles] = useState([]);

    const [employees, setEmployees] = useState([]);
    const [totalEmployees, setTotalEmployees] = useState(0);
    const [addingEmployee, setAddingEmployee] = useState(false);

    function acceptEmployerRequest(event, id) {
        const node = event.currentTarget;

        swal.fire({
            title: "Are you sure you want to accept this request ?",
            showCancelButton: true,
            confirmButtonText: "Yes!"
        }).then(async function (result) {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                node.setAttribute("disabled", "disabled");

                try {
                    const formData = new FormData();
                    formData.append("id", id);

                    const response = await axios.post(
                        baseUrl + "/api/employees/accept-request",
                        formData,
                        {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                            }
                        }
                    );

                    if (response.data.status == "success") {
                        const tempArr = [ ...employees ];
                        for (let a = 0; a < tempArr.length; a++) {
                            if (tempArr[a].id == id) {
                                tempArr[a].status = "accepted";
                                break;
                            }
                        }
                        setEmployees(tempArr);
                    } else {
                        swal.fire("Error", response.data.message, "error");
                    }
                } catch (exp) {
                    console.log(exp.message);
                } finally {
                    node.removeAttribute("disabled");
                }
            }
        });
    }

    function declineEmployerRequest(event, id) {
        const node = event.currentTarget;

        swal.fire({
            title: "Are you sure you want to decline this request ?",
            showCancelButton: true,
            confirmButtonText: "Yes!"
        }).then(async function (result) {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                node.setAttribute("disabled", "disabled");

                try {
                    const formData = new FormData();
                    formData.append("id", id);

                    const response = await axios.post(
                        baseUrl + "/api/employees/decline-request",
                        formData,
                        {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                            }
                        }
                    );

                    if (response.data.status == "success") {
                        const tempArr = [ ...employees ];
                        for (let a = 0; a < tempArr.length; a++) {
                            if (tempArr[a].id == id) {
                                tempArr[a].status = "declined";
                                break;
                            }
                        }
                        setEmployees(tempArr);
                    } else {
                        swal.fire("Error", response.data.message, "error");
                    }
                } catch (exp) {
                    console.log(exp.message);
                } finally {
                    node.removeAttribute("disabled");
                }
            }
        });
    }

    function removeEmployer(event, id) {
        const node = event.currentTarget;

        swal.fire({
            title: "Are you sure you want to remove this request ?",
            showCancelButton: true,
            confirmButtonText: "Yes!"
        }).then(async function (result) {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                node.setAttribute("disabled", "disabled");

                try {
                    const formData = new FormData();
                    formData.append("id", id);

                    const response = await axios.post(
                        baseUrl + "/api/employees/remove-request",
                        formData,
                        {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                            }
                        }
                    );

                    if (response.data.status == "success") {
                        const tempArr = [ ...employees ];
                        for (let a = 0; a < tempArr.length; a++) {
                            if (tempArr[a].id == id) {
                                tempArr.splice(a, 1);
                                break;
                            }
                        }
                        setEmployees(tempArr);
                    } else {
                        swal.fire("Error", response.data.message, "error");
                    }
                } catch (exp) {
                    console.log(exp.message);
                } finally {
                    node.removeAttribute("disabled");
                }
            }
        });
    }

    async function addEmployee() {
        setAddingEmployee(true);

        try {
            const formData = new FormData();
            formData.append("time_zone", Intl.DateTimeFormat().resolvedOptions().timeZone || "");
            formData.append("email", document.getElementById("employee-email").value || "");

            const response = await axios.post(
                baseUrl + "/api/employees/create",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                swal.fire("Add Employee", response.data.message, "success");

                const temp = response.data.employee;
                const tempArr = [ ...employees ];
                tempArr.unshift(temp);
                setEmployees(tempArr);

                document.getElementById("employee-email").value = "";
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setAddingEmployee(false);
        }
    }

    function removeEmployee(event, id) {
        const node = event.currentTarget;

        swal.fire({
            title: "Are you sure you want to remove this employee ?",
            showCancelButton: true,
            confirmButtonText: "Yes!"
        }).then(async function (result) {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                node.setAttribute("disabled", "disabled");

                try {
                    const formData = new FormData();
                    formData.append("id", id);

                    const response = await axios.post(
                        baseUrl + "/api/employees/delete",
                        formData,
                        {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                            }
                        }
                    );

                    if (response.data.status == "success") {
                        const tempArr = [ ...employees ];
                        for (let a = 0; a < tempArr.length; a++) {
                            if (tempArr[a].id == id) {
                                tempArr.splice(a, 1);
                                break;
                            }
                        }
                        setEmployees(tempArr);
                    } else {
                        swal.fire("Error", response.data.message, "error");
                    }
                } catch (exp) {
                    console.log(exp.message);
                } finally {
                    node.removeAttribute("disabled");
                }
            }
        });
    }

    function deletePost(event, id) {
        const node = event.currentTarget;

        swal.fire({
            title: "Are you sure you want to delete this post ?",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it."
        }).then(async function (result) {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                node.setAttribute("disabled", "disabled");

                try {
                    const formData = new FormData();
                    formData.append("id", id);

                    const response = await axios.post(
                        baseUrl + "/api/posts/delete",
                        formData,
                        {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                            }
                        }
                    );

                    if (response.data.status == "success") {
                        const tempArr = [ ...posts ];
                        for (let a = 0; a < tempArr.length; a++) {
                            if (tempArr[a].id == id) {
                                tempArr.splice(a, 1);
                                break;
                            }
                        }
                        setPosts(tempArr);
                    } else {
                        swal.fire("Error", response.data.message, "error");
                    }
                } catch (exp) {
                    console.log(exp.message);
                } finally {
                    node.removeAttribute("disabled");
                }
            }
        });
    }

    async function submitPost() {
        setSubmittingPost(true);

        try {
            const formData = new FormData();
            formData.append("time_zone", Intl.DateTimeFormat().resolvedOptions().timeZone || "");
            formData.append("caption", document.getElementById("post_caption").value || "");

            Array.from(postSelectedFiles).map(function (file) {
                formData.append("files[]", file);
            });

            const response = await axios.post(
                baseUrl + "/api/posts/create",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const temp = response.data.post;
                const tempArr = [ ...posts ];
                tempArr.unshift(temp);
                setPosts(tempArr);

                setPostSelectedFiles([]);
                document.getElementById("post_caption").value = "";
                document.getElementById("post-files").value = "";
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setSubmittingPost(false);
        }
    }

    async function fetchProfile() {
        if (!hasFetchedProfile) {
            setLoading(true);
            try {
                const response = await axios.post(
                    baseUrl + "/api/my-profile",
                    null,
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                        }
                    }
                );

                if (response.data.status == "success") {
                    setProjects(response.data.projects);
                    setPosts(response.data.posts);
                    setEmployees(response.data.employees);
                    setTotalEmployees(response.data.total_employees);
                    setHasFetchedProfile(true);

                    setTimeout(function () {
                        initCollapsible();
                    }, 1000);
                } else {
                    swal.fire("Error", response.data.message, "error");
                }
            } catch (exp) {
                console.log(exp.message);
            } finally {
                setLoading(false);
            }
        }
    }

    function initCollapsible() {
        const toggle = document.querySelectorAll(".collapsible-toggle");
        const content = document.querySelectorAll(".collapsible-content");

        for (let a = 0; a < toggle.length; a++) {
            toggle[a].addEventListener("click", function () {
                const isVisible = content[a].style.display === "block";
                content[a].style.display = isVisible ? "none" : "block";
            });
        }
    }

    async function addFilesInProject(id, files) {
        try {
            const formData = new FormData();
            formData.append("id", id);

            files.map(function (file) {
                formData.append("files[]", file);
            });

            const response = await axios.post(
                baseUrl + "/api/projects/add-files",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const newFiles = response.data.files;
                const temp = [ ...projects ];
                for (let a = 0; a < temp.length; a++) {
                    if (temp[a].id == id) {
                        for (let b = 0; b < newFiles.length; b++) {
                            temp[a].files.push(newFiles[b]);
                        }
                        break;
                    }
                }
                setProjects(temp);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        }
    }

    function removeFileFromProject(event, id, path, type) {
        const node = event.currentTarget;

        swal.fire({
            title: "Are you sure you want to delete this " + type.split("/")[0] + " ?",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it."
        }).then(async function (result) {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                node.setAttribute("disabled", "disabled");

                try {
                    const formData = new FormData();
                    formData.append("id", id);
                    formData.append("path", path);

                    const response = await axios.post(
                        baseUrl + "/api/projects/delete-file",
                        formData,
                        {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                            }
                        }
                    );

                    if (response.data.status == "success") {
                        const temp = [ ...projects ];
                        for (let a = 0; a < temp.length; a++) {
                            if (temp[a].id == id) {
                                for (let b = 0; b < temp[a].files.length; b++) {
                                    if (temp[a].files[b].path == path) {
                                        temp[a].files.splice(b, 1);
                                        break;
                                    }
                                }
                                break;
                            }
                        }
                        setProjects(temp);
                    } else {
                        swal.fire("Error", response.data.message, "error");
                    }
                } catch (exp) {
                    console.log(exp.message);
                } finally {
                    node.removeAttribute("disabled");
                }
            }
        });
    }

    function deleteProject(index) {
        const project = projects[index];

        swal.fire({
            title: "Are you sure you want to delete the project '" + project.title + "' ?",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it."
        }).then(async function (result) {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                setDeletingProject(true);

                try {
                    const formData = new FormData();
                    formData.append("id", project.id);

                    const response = await axios.post(
                        baseUrl + "/api/projects/delete",
                        formData,
                        {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                            }
                        }
                    );

                    if (response.data.status == "success") {
                        const temp = [ ...projects ];
                        temp.splice(index, 1);
                        setProjects(temp);
                    } else {
                        swal.fire("Error", response.data.message, "error");
                    }
                } catch (exp) {
                    console.log(exp.message);
                } finally {
                    setDeletingProject(false);
                }
            }
        });
    }

    async function updateProject(index) {
        setUpdatingProject(true);
        const project = projects[index];

        try {
            const formData = new FormData();
            formData.append("id", project.id);
            formData.append("title", project.title);
            formData.append("url", project.url);
            formData.append("time_took", project.time_took);
            formData.append("description", project.description);

            const response = await axios.post(
                baseUrl + "/api/projects/update",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                swal.fire("Update project", response.data.message, "success");
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setUpdatingProject(false);
        }
    }

    async function addProject() {
        setAddingProject(true);

        try {
            const form = document.getElementById("form-update-profile");
            const formData = new FormData();

            Array.from(form.project_file.files).map(function (file) {
                formData.append("files[]", file);
            });

            formData.append("title", form.project_name.value || "");
            formData.append("url", form.project_url.value || "");
            formData.append("time_took", form.project_time_took.value || "");
            formData.append("description", form.project_description.value || "");
            
            const response = await axios.post(
                baseUrl + "/api/projects/add",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const project = response.data.project;
                const temp = [ ...projects ];
                temp.unshift(project);
                setProjects(temp);

                setTimeout(function () {
                    initCollapsible();
                }, 1000);

                swal.fire("Add project", response.data.message, "success");
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setAddingProject(false);
        }
    }

    async function changePassword() {
        setChangingPassword(true);

        try {
            const form = document.getElementById("form-change-password");
            const formData = new FormData(form);

            const response = await axios.post(
                baseUrl + "/api/change-password",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                swal.fire("Change password", response.data.message, "success");
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setChangingPassword(false);
        }
    }

    async function updateProfile() {
        setUpdatingProfile(true);

        try {
            const form = document.getElementById("form-update-profile");
            const formData = new FormData(form);

            formData.append("education", JSON.stringify(education));
            formData.append("experiences", JSON.stringify(experiences));
            formData.append("certificates", JSON.stringify(certificates));

            const response = await axios.post(
                baseUrl + "/api/save-profile",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                swal.fire("Profile", response.data.message, "success");
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setUpdatingProfile(false);
        }
    }

    async function fetchPayments() {
        setFetchingPayments(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formData = new FormData();
            formData.append("page", paymentsPage);
            formData.append("time_zone", timeZone);

            const response = await axios.post(
                baseUrl + "/api/payments/my",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setPayments(response.data.payments);
                setPaymentsPages(response.data.pages);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setFetchingPayments(false);
        }
    }

    async function fetchReceipts() {
        setFetchingReceipts(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formData = new FormData();
            formData.append("page", paymentsPage);
            formData.append("time_zone", timeZone);

            const response = await axios.post(
                baseUrl + "/api/receipts/my",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setReceipts(response.data.receipts);
                setReceiptsPages(response.data.pages);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setFetchingReceipts(false);
        }
    }

    useEffect(function () {
        globalState.listen(function (newState, updatedState) {
            setState(newState);

            if (newState.user != null) {
                setEducation(newState.user.education || []);
                setExperiences(newState.user.experiences || []);
                setCertificates(newState.user.certificates || []);
            }
        });
    }, []);

    useEffect(function () {
        if (pageType == "profile") {
            setPageName("My Profile")
            fetchProfile();
        } else if (pageType == "receipts") {
            if (receipts.length <= 0) {
                fetchReceipts();
            }

            setPageName("Receipts");
        } else if (pageType == "payments") {
            if (payments.length <= 0) {
                fetchPayments();
            }
            setPageName("Payments");
        }
    }, [pageType]);

    const styles = {
        profileImage: {
            width: "100px"
        },
        projectImage: {
            width: "200px"
        },
        summary: {
            minHeight: "150px"
        },
        ...(state.user?.cover_photo ? {
            coverPhoto: {
                backgroundImage: "url(" + state.user?.cover_photo + ")",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "top"
            }
        } : {}),
        postMedia: {
            width: "100px",
            borderRadius: "5px"
        },
        employeeImage: {
            width: "100px",
            height: "100px",
            objectFit: "cover",
            borderRadius: "50%"
        }
    };

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5"
                style={ styles.coverPhoto }>
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">{ pageName }</h1>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">{ pageName }</li>
                        </ol>
                    </nav>
                </div>
            </div>

            { pageType == "profile" && (
                <div className="container-xxl wow fadeInUp" data-wow-delay="0.1s">
                    <div className="container">
                        <div className="row">
                            <div className="offset-md-9 col-md-3">

                                { state.user?.type == "job_seeker" ? (
                                    <Link to={ `/user/${ state.user?.id }` }
                                        className="me-3">View profile</Link>
                                ) : state.user?.type == "recruiter" && (
                                    <Link to={ `/recruiter/${ state.user?.id }` }
                                        className="me-3">View profile</Link>
                                ) }

                                <button type="button" className="btn btn-primary"
                                    onClick={ function () {
                                        document.getElementById("input-cover-photo").click();
                                    } }>Update cover photo</button>
                            </div>
                        </div>
                    </div>
                </div>
            ) }

            <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container">
                    <div className="row">
                        <div className="col-md-2">
                            <div className="profile-container">
                                <div className="sidebar">
                                    <ul>
                                        <li>
                                            <a href="#" className={ pageType == "profile" ? "active" : "" } onClick={ function (event) {
                                                event.preventDefault();
                                                setPageType("profile");
                                                window.history.pushState({}, "", "/profile");
                                            } }>Profile</a>
                                        </li>

                                        { state.user?.type == "recruiter" && (
                                            <>
                                                <li>
                                                    <a href="#" className={ pageType == "receipts" ? "active" : "" } onClick={ function (event) {
                                                        event.preventDefault();
                                                        setPageType("receipts");
                                                        window.history.pushState({}, "", "/profile/receipts");
                                                    } }>Receipts</a>
                                                </li>

                                                <li>
                                                    <a href="#" className={ pageType == "payments" ? "active" : "" } onClick={ function (event) {
                                                        event.preventDefault();
                                                        setPageType("payments");
                                                        window.history.pushState({}, "", "/profile/payments");
                                                    } }>Payments</a>
                                                </li>
                                            </>
                                        ) }

                                        <li>
                                            <a href="#" className={ pageType == "change-password" ? "active" : "" } onClick={ function (event) {
                                                event.preventDefault();
                                                setPageType("change-password");
                                                window.history.pushState({}, "", "/profile/change-password");
                                            } }>Change password</a>
                                        </li>
                                    </ul>
                                </div>                                
                            </div>
                        </div>

                        <div className="col-md-10">

                            { pageType == "profile" ? (
                                <div className="profile-content">
                                    <div className="profile-details">
                                        <form onSubmit={ function (event) {
                                            event.preventDefault();
                                            updateProfile();
                                        } } encType="multipart/form-data"
                                            id="form-update-profile"
                                            noValidate>

                                            <input type="file" name="cover_photo" id="input-cover-photo"
                                                accept="image/*"
                                                className="hide"
                                                onChange={ function (event) {
                                                    var file = event.target.files
                                                    if (file.length > 0) {
                                                        var fileReader = new FileReader()
                                             
                                                        fileReader.onload = function (e) {
                                                            if (state.user != null) {
                                                                state.user.cover_photo = e.target.result;
                                                                globalState.setState(state);
                                                            }
                                                        }
                                             
                                                        fileReader.readAsDataURL(file[0])
                                                    }
                                                } } />

                                            <div className="row mt-5">
                                                <div className="col-md-2">
                                                    { state.user?.profile_image && (
                                                        <img src={ state.user.profile_image }
                                                            style={ styles.profileImage }
                                                            className="mb-5" />
                                                    ) }
                                                </div>

                                                <div className="col-md-10">
                                                    <div className="row g-3">
                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <input type="text" className="form-control" name="name" required
                                                                    defaultValue={ state.user?.name || "" } />
                                                                <label>Name</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <input type="email" className="form-control" name="email" disabled
                                                                    defaultValue={ state.user?.email || "" } />
                                                                <label>Email</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <input type="file" accept="image/*" className="form-control bg-white"
                                                                    name="profile_image" />
                                                                <label>Profile Image</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <input type="text" className="form-control" name="about" defaultValue={ state.user?.about || "" } />
                                                                <label>About</label>
                                                            </div>
                                                        </div>

                                                        { state.user?.type == "job_seeker" && (
                                                            <div className="col-md-6">
                                                                <div className="form-floating">
                                                                    <input type="text" className="form-control" name="currently_working" defaultValue={ state.user?.currently_working || "" } />
                                                                    <label>Working at</label>
                                                                </div>
                                                            </div>
                                                        ) }

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <input type="text" className="form-control" name="currently_located" defaultValue={ state.user?.currently_located || "" } />
                                                                <label>Located in</label>
                                                            </div>
                                                        </div>

                                                        { state.user?.type == "job_seeker" && (
                                                            <div className="col-md-12">
                                                                <div className="form-floating">
                                                                    <textarea className="form-control" name="summary"
                                                                        value={ state.user?.summary || "" }
                                                                        onChange={ function (event) {
                                                                            if (state.user != null) {
                                                                                state.user.summary = event.target.value || "";
                                                                                globalState.setState(state);
                                                                            }
                                                                        } }
                                                                        style={ styles.summary }></textarea>
                                                                    <label>Summary</label>
                                                                </div>
                                                            </div>
                                                        ) }
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={ isPremium ? "" : "blur-overlay" }>

                                                { !isPremium && (
                                                    <div className="blur-message">
                                                        <p>{ premiumMessage }</p>
                                                    </div>
                                                ) }

                                                <div className="row mt-5">
                                                    <div className="col-md-12">
                                                        <div className="row g-3">
                                                            <div className="col-md-12">
                                                                <div className="form-floating">
                                                                    <textarea className="form-control" id="post_caption"
                                                                        rows="10"></textarea>
                                                                    <label>What's in your mind ?</label>
                                                                </div>

                                                                <input type="file" multiple accept="image/*, video/*"
                                                                    className="display-none"
                                                                    name="post_files[]"
                                                                    id="post-files"
                                                                    onChange={ function (event) {
                                                                        setPostSelectedFiles(event.target.files);
                                                                    } } />

                                                                <button type="button" className={ "btn btn-link " + (postSelectedFiles.length > 0 ? "mt-3" : "") }
                                                                    onClick={ function () {
                                                                        document.getElementById("post-files").click();
                                                                    } }>
                                                                    <i className="fa fa-paperclip"></i>

                                                                    { postSelectedFiles.length > 0 && (
                                                                        <span className="ms-2">{ postSelectedFiles.length } file(s) selected.</span>
                                                                    ) }
                                                                </button>
                                                            </div>

                                                            <div className="col-md-12">
                                                                <button type="button" className="btn btn-outline-primary"
                                                                    disabled={ submittingPost }
                                                                    onClick={ function () {
                                                                        submitPost();
                                                                    } }>Post</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                { state.user?.type == "recruiter" ? (
                                                    <>
                                                        <div className="row mt-5 mb-3">
                                                            <div className="col-md-12">
                                                                <h2>Employees</h2>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-3 mb-3">
                                                            <div className="col-md-6">
                                                                <div className="form-floating">
                                                                    <input type="email" name="employee_email" id="employee-email" className="form-control" />
                                                                    <label>Employee's email address</label>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <button type="button" className="btn btn-outline-primary"
                                                                    disabled={ addingEmployee }
                                                                    onClick={ function () {
                                                                        addEmployee();
                                                                    } }>Add</button>
                                                            </div>
                                                        </div>

                                                        <table className="employee-table">
                                                            <thead>
                                                                <tr>
                                                                    <th>Name</th>
                                                                    <th>Email</th>
                                                                    <th>Status</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                { employees.map(function (emp, empIndex) {
                                                                    return (
                                                                        <tr key={ `employee-${ emp.id }` }>
                                                                            <td>
                                                                                { emp.employee?.profile_image && (
                                                                                    <img src={ emp.employee.profile_image }
                                                                                        style={ styles.employeeImage }
                                                                                        className="me-3" />
                                                                                ) }

                                                                                { emp.employee?.name }
                                                                            </td>
                                                                            <td>{ emp.employee?.email }</td>
                                                                            <td><span className={ `badge text-capitalize ${ emp.status }` }>{ emp.status }</span></td>
                                                                            <td>
                                                                                <button type="button" className="btn btn-danger" onClick={ function (event) {
                                                                                    removeEmployee(event, emp.id);
                                                                                } }>
                                                                                    Delete &nbsp; <i className="fa fa-trash"></i>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }) }
                                                            </tbody>
                                                        </table>
                                                    </>
                                                ) : state.user?.type == "job_seeker" && (
                                                    <>
                                                        { employees.length > 0 && (
                                                            <>
                                                                <div className="row mt-5 mb-3">
                                                                    <div className="col-md-12">
                                                                        <h2>Employers</h2>
                                                                    </div>
                                                                </div>

                                                                <table className="employee-table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Name</th>
                                                                            <th>Email</th>
                                                                            <th>Status</th>
                                                                            <th>Action</th>
                                                                        </tr>
                                                                    </thead>

                                                                    <tbody>
                                                                        { employees.map(function (emp, empIndex) {
                                                                            return (
                                                                                <tr key={ `employee-${ emp.id }` }>
                                                                                    <td>
                                                                                        { emp.employee?.profile_image && (
                                                                                            <img src={ emp.employee.profile_image }
                                                                                                style={ styles.employeeImage }
                                                                                                className="me-3" />
                                                                                        ) }

                                                                                        { emp.employee?.name }
                                                                                    </td>
                                                                                    <td>{ emp.employee?.email }</td>
                                                                                    <td><span className={ `badge text-capitalize ${ emp.status }` }>{ emp.status }</span></td>
                                                                                    <td>
                                                                                        { emp.status == "pending" && (
                                                                                            <>
                                                                                                <button type="button" className="btn btn-primary me-3" onClick={ function (event) {
                                                                                                    acceptEmployerRequest(event, emp.id);
                                                                                                } }>
                                                                                                    Accept &nbsp; <i className="fa fa-check"></i>
                                                                                                </button>

                                                                                                <button type="button" className="btn btn-danger me-3" onClick={ function (event) {
                                                                                                    declineEmployerRequest(event, emp.id);
                                                                                                } }>
                                                                                                    Decline &nbsp; <i className="fa fa-close"></i>
                                                                                                </button>
                                                                                            </>
                                                                                        ) }

                                                                                        { ["accepted", "declined"].includes(emp.status) && (
                                                                                            <button type="button" className="btn btn-danger" onClick={ function (event) {
                                                                                                removeEmployer(event, emp.id);
                                                                                            } }>
                                                                                                Remove &nbsp; <i className="fa fa-trash"></i>
                                                                                            </button>
                                                                                        ) }
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        }) }
                                                                    </tbody>
                                                                </table>
                                                            </>
                                                        ) }
                                                    </>
                                                ) }

                                                { posts.length > 0 && (
                                                    <div className="row mt-5 mb-3">
                                                        <div className="col-md-12">
                                                            <h2>Posts</h2>
                                                        </div>
                                                    </div>
                                                ) }

                                                { loading && (
                                                    <div className="row mt-5 mb-3">
                                                        <div className="col-md-12">
                                                            <Loader />
                                                        </div>
                                                    </div>
                                                ) }

                                                { posts.map(function (post, index) {
                                                    return (
                                                        <div className="row" key={ `post-${ post.id }` }>
                                                            <div className="col-md-12">
                                                                <div className="post">
                                                                    <div className="post-header">
                                                                        <img className="avatar" src={ post.user.profile_image }
                                                                            alt={ post.user.name } />
                                                                        
                                                                        <div className="post-meta">
                                                                            <span className="username">{ post.user.name }</span>
                                                                            <span className="timestamp">{ post.created_at_relative }</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="post-content">
                                                                        { post.caption }

                                                                        { post.files.map(function (file, fileIndex) {
                                                                            return (
                                                                                <div key={ `post-${ post.id }-file-${ fileIndex} ` }
                                                                                    className="mt-3">
                                                                                    { file.type.includes("image") ? (
                                                                                        <img src={ file.path } style={ styles.postMedia } />
                                                                                    ) : file.type.includes("image") && (
                                                                                        <video src={ file.path } style={ styles.postMedia }></video>
                                                                                    ) }
                                                                                </div>
                                                                            );
                                                                        }) }
                                                                    </div>

                                                                    <div className="post-footer">
                                                                        <button type="button" className="like-btn" onClick={ function (event) {
                                                                            deletePost(event, post.id);
                                                                        } }>
                                                                            Delete &nbsp; <i className="fa fa-trash"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                }) }
                                            </div>

                                            { state.user?.type == "job_seeker" && (
                                                <>
                                                    <div className="row mt-5 mb-3">
                                                        <div className="col-md-12">
                                                            <h2>Job preferences</h2>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <input type="text" name="desired_job_title" className="form-control" placeholder="Desired job title (separated by commas)"
                                                                    value={ state.user?.desired_job_title || "" }
                                                                    onChange={ function (event) {
                                                                        if (state.user != null) {
                                                                            state.user.desired_job_title = event.target.value || "";
                                                                            globalState.setState(state);
                                                                        }
                                                                    } } />
                                                                <label>Desired job title (separated by commas)</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 mb-3">
                                                            <div className="form-floating">
                                                                <input type="text" name="desired_salary" className="form-control" placeholder="Desired salary"
                                                                    value={ state.user?.desired_salary || "" }
                                                                    onChange={ function (event) {
                                                                        if (state.user != null) {
                                                                            state.user.desired_salary = event.target.value || "";
                                                                            globalState.setState(state);
                                                                        }
                                                                    } } />
                                                                <label>Desired salary</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <input type="text" name="desired_cities" className="form-control" placeholder="Cities (separated by commas)"
                                                                    value={ state.user?.desired_cities || "" }
                                                                    onChange={ function (event) {
                                                                        if (state.user != null) {
                                                                            state.user.desired_cities = event.target.value || "";
                                                                            globalState.setState(state);
                                                                        }
                                                                    } } />
                                                                <label>Cities (separated by commas)</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="form-floating">
                                                                <input type="text" name="desired_skills" className="form-control" placeholder="Skills (separated by commas)"
                                                                    value={ state.user?.desired_skills || "" }
                                                                    onChange={ function (event) {
                                                                        if (state.user != null) {
                                                                            state.user.desired_skills = event.target.value || "";
                                                                            globalState.setState(state);
                                                                        }
                                                                    } } />
                                                                <label>Skills (separated by commas)</label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className={ isPremium ? "" : "blur-overlay" }>

                                                        { !isPremium && (
                                                            <div className="blur-message">
                                                                <p>{ premiumMessage }</p>
                                                            </div>
                                                        ) }

                                                        <div className="row mt-5">
                                                            <div className="col-md-12 mb-3">
                                                                <h2>Projects</h2>
                                                            </div>

                                                            <p>
                                                                <a className="btn btn-primary" data-bs-toggle="collapse" href="#collapseAddProject" role="button" aria-expanded="false" aria-controls="collapseAddProject">
                                                                    Add project
                                                                </a>
                                                            </p>

                                                            <div className="collapse" id="collapseAddProject">
                                                                <div className="row">
                                                                    <div className="col-md-12 mb-3">
                                                                        <div className="form-floating">
                                                                            <input type="file" multiple name="project_file" accept="image/*, video/*" className="form-control bg-white" />
                                                                            <label>Image</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <div className="form-floating">
                                                                            <input type="text" name="project_name" className="form-control" />
                                                                            <label>Name</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <div className="form-floating">
                                                                            <input type="url" name="project_url" className="form-control" />
                                                                            <label>URL</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <div className="form-floating">
                                                                            <input type="text" name="project_time_took" className="form-control" />
                                                                            <label>Time took (e.g. 6 months)</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-12 mt-3">
                                                                        <div className="form-floating">
                                                                            <textarea name="project_description" className="form-control" style={ styles.summary }></textarea>
                                                                            <label>Description</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-12 mt-3">
                                                                        <button className="btn btn-primary w-100 py-3"
                                                                            type="button"
                                                                            disabled={ addingProject }
                                                                            onClick={ function () {
                                                                                addProject();
                                                                            } }>Add project</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            { projects.map(function (project, index) {
                                                                return (
                                                                    <div className="col-md-12 mt-3" key={ `project-${ index }` }>
                                                                        <div className="collapsible-container">
                                                                            <button type="button" className="btn btn-warning collapsible-toggle">Title: { project.title }</button>

                                                                            <div className="collapsible-content">
                                                                                <div className="row">
                                                                                    <div className="col-md-12 mb-3">
                                                                                        <div className="form-floating mb-3">
                                                                                            <input type="file" multiple accept="image/*, video/*" className="form-control bg-white"
                                                                                                onChange={ function (event) {
                                                                                                    const files = Array.from(event.target.files);
                                                                                                    addFilesInProject(project.id, files);
                                                                                                } } />
                                                                                            <label>Image</label>
                                                                                        </div>

                                                                                        { project.files.map(function (file, fileIndex) {
                                                                                            return (
                                                                                                <div key={ `file-${ fileIndex }` } className="display-inline-block me-5">
                                                                                                    { file.type.includes("image") ? (
                                                                                                        <img src={ file.path } style={ styles.projectImage } />
                                                                                                    ) : file.type.includes("video") && (
                                                                                                        <video src={ file.path } style={ styles.projectImage }></video>
                                                                                                    ) }

                                                                                                    <br />

                                                                                                    <button type="button" className="btn btn-danger mt-2"
                                                                                                        onClick={ function (event) {
                                                                                                            removeFileFromProject(event, project.id, file.path, file.type);
                                                                                                        } }>
                                                                                                        <i className="fa fa-close"></i>
                                                                                                    </button>
                                                                                                </div>
                                                                                            );
                                                                                        }) }
                                                                                    </div>

                                                                                    <div className="col-md-4">
                                                                                        <div className="form-floating">
                                                                                            <input type="text" name="unused_title" className="form-control"
                                                                                                value={ project.title }
                                                                                                onChange={ function (event) {
                                                                                                    const temp = [ ...projects ];
                                                                                                    temp[index].title = event.target.value || "";
                                                                                                    setProjects(temp);
                                                                                                } } />
                                                                                            <label>Name</label>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-md-4">
                                                                                        <div className="form-floating">
                                                                                            <input type="url" name="unused_url" className="form-control"
                                                                                                value={ project.url }
                                                                                                onChange={ function (event) {
                                                                                                    const temp = [ ...projects ];
                                                                                                    temp[index].url = event.target.value || "";
                                                                                                    setProjects(temp);
                                                                                                } } />
                                                                                            <label>URL</label>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-md-4">
                                                                                        <div className="form-floating">
                                                                                            <input type="text" name="unused_time_took" className="form-control"
                                                                                                value={ project.time_took }
                                                                                                onChange={ function (event) {
                                                                                                    const temp = [ ...projects ];
                                                                                                    temp[index].time_took = event.target.value || "";
                                                                                                    setProjects(temp);
                                                                                                } } />
                                                                                            <label>Time took (e.g. 6 months)</label>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-md-12 mt-3">
                                                                                        <div className="form-floating">
                                                                                            <textarea className="form-control"
                                                                                                name="unused_summary"
                                                                                                style={ styles.summary }
                                                                                                value={ project.description }
                                                                                                onChange={ function (event) {
                                                                                                    const temp = [ ...projects ];
                                                                                                    temp[index].description = event.target.value || "";
                                                                                                    setProjects(temp);
                                                                                                } }></textarea>
                                                                                            <label>Description</label>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-md-12 mt-3">
                                                                                        <button className="btn btn-warning py-3"
                                                                                            type="button"
                                                                                            disabled={ updatingProject }
                                                                                            onClick={ function () {
                                                                                                updateProject(index);
                                                                                            } }>Update project</button>

                                                                                        <button className="btn btn-danger py-3 ms-3"
                                                                                            type="button"
                                                                                            disabled={ deletingProject }
                                                                                            onClick={ function () {
                                                                                                deleteProject(index);
                                                                                            } }>Delete project</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }) }
                                                        </div>

                                                        <div className="row mt-5 mb-3">
                                                            <div className="col-md-12">
                                                                <h2>Education</h2>
                                                            </div>
                                                        </div>

                                                        { education.map(function (d, index) {
                                                            return (
                                                                <div className="row mb-3 education" key={ `education-${ index }` }>
                                                                    <div className="col-md-4">
                                                                        <div className="form-floating">
                                                                            <input type="text" className="form-control degree" placeholder="Degree"
                                                                                value={ d.degree || "" }
                                                                                onChange={ function (event) {
                                                                                    const temp = [ ...education ];
                                                                                    temp[index].degree = event.target.value || "";
                                                                                    setEducation(temp);
                                                                                } } />
                                                                            <label>Degree</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <div className="form-floating">
                                                                            <input type="text" className="form-control institute" placeholder="Institute"
                                                                                value={ d.institute || "" }
                                                                                onChange={ function (event) {
                                                                                    const temp = [ ...education ];
                                                                                    temp[index].institute = event.target.value || "";
                                                                                    setEducation(temp);
                                                                                } } />
                                                                            <label>Institute</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4 display-ruby">
                                                                        <div className="form-floating">
                                                                            <input type="text" className="form-control year" placeholder="Year"
                                                                                value={ d.year || "" }
                                                                                onChange={ function (event) {
                                                                                    const temp = [ ...education ];
                                                                                    temp[index].year = event.target.value || "";
                                                                                    setEducation(temp);
                                                                                } } />
                                                                            <label>Year</label>
                                                                        </div>

                                                                        <button type="button" className="btn btn-danger ms-3"
                                                                            onClick={ function (event) {
                                                                                const temp = [ ...education ];
                                                                                temp.splice(index, 1);
                                                                                setEducation(temp);
                                                                            } }>
                                                                            <i className="fa fa-close"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }) }

                                                        <a href="#" onClick={ function (event) {
                                                            event.preventDefault();

                                                            const temp = [ ...education ];
                                                            temp.push({
                                                                degree: "",
                                                                institute: "",
                                                                year: ""
                                                            });
                                                            setEducation(temp);
                                                        } }>+ Add more</a>

                                                        <div className="row mt-5 mb-3">
                                                            <div className="col-md-12">
                                                                <h2>Experiences</h2>
                                                            </div>
                                                        </div>

                                                        { experiences.map(function (d, index) {
                                                            return (
                                                                <div className="row mb-3 experiences" key={ `experiences-${ index }` }>
                                                                    <div className="col-md-3">
                                                                        <div className="form-floating">
                                                                            <input type="text" className="form-control name" placeholder="Company name"
                                                                                value={ d.name || "" }
                                                                                onChange={ function (event) {
                                                                                    const temp = [ ...experiences ];
                                                                                    temp[index].name = event.target.value || "";
                                                                                    setExperiences(temp);
                                                                                } } />
                                                                            <label>Company Name</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-3">
                                                                        <div className="form-floating">
                                                                            <input type="text" className="form-control from" placeholder="From"
                                                                                value={ d.from || "" }
                                                                                onChange={ function (event) {
                                                                                    const temp = [ ...experiences ];
                                                                                    temp[index].from = event.target.value || "";
                                                                                    setExperiences(temp);
                                                                                } } />
                                                                            <label>From</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-3">
                                                                        <div className="form-floating">
                                                                            <input type="text" className="form-control to" placeholder="To"
                                                                                value={ d.to || "" }
                                                                                onChange={ function (event) {
                                                                                    const temp = [ ...experiences ];
                                                                                    temp[index].to = event.target.value || "";
                                                                                    setExperiences(temp);
                                                                                } } />
                                                                            <label>To</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-3 display-ruby">
                                                                        <div className="form-floating">
                                                                            <input type="text" className="form-control designation" placeholder="Designation"
                                                                                value={ d.designation || "" }
                                                                                onChange={ function (event) {
                                                                                    const temp = [ ...experiences ];
                                                                                    temp[index].designation = event.target.value || "";
                                                                                    setExperiences(temp);
                                                                                } } />
                                                                            <label>Designation</label>
                                                                        </div>

                                                                        <button type="button" className="btn btn-danger ms-2"
                                                                            onClick={ function (event) {
                                                                                const temp = [ ...experiences ];
                                                                                temp.splice(index, 1);
                                                                                setExperiences(temp);
                                                                            } }>
                                                                            <i className="fa fa-close"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }) }

                                                        <a href="#" onClick={ function (event) {
                                                            event.preventDefault();

                                                            const temp = [ ...experiences ];
                                                            temp.push({
                                                                name: "",
                                                                from: "",
                                                                to: "",
                                                                designation: ""
                                                            });
                                                            setExperiences(temp);
                                                        } }>+ Add more</a>

                                                        <div className="row mt-5 mb-3">
                                                            <div className="col-md-12">
                                                                <h2>Certificates</h2>
                                                            </div>
                                                        </div>

                                                        { certificates.map(function (d, index) {
                                                            return (
                                                                <div className="row mb-3 certificates" key={ `certificates-${ index }` }>
                                                                    <div className="col-md-4">
                                                                        <div className="form-floating">
                                                                            <input type="text" className="form-control name" placeholder="Name"
                                                                                value={ d.name || "" }
                                                                                onChange={ function (event) {
                                                                                    const temp = [ ...certificates ];
                                                                                    temp[index].name = event.target.value || "";
                                                                                    setCertificates(temp);
                                                                                } } />
                                                                            <label>Name</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <div className="form-floating">
                                                                            <input type="text" className="form-control year" placeholder="Year"
                                                                                value={ d.year || "" }
                                                                                onChange={ function (event) {
                                                                                    const temp = [ ...certificates ];
                                                                                    temp[index].year = event.target.value || "";
                                                                                    setCertificates(temp);
                                                                                } } />
                                                                            <label>Year</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <button type="button" className="btn btn-danger ms-2"
                                                                            onClick={ function (event) {
                                                                                const temp = [ ...certificates ];
                                                                                temp.splice(index, 1);
                                                                                setCertificates(temp);
                                                                            } }>
                                                                            <i className="fa fa-close"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }) }

                                                        <a href="#" onClick={ function (event) {
                                                            event.preventDefault();

                                                            const temp = [ ...certificates ];
                                                            temp.push({
                                                                name: "",
                                                                year: ""
                                                            });
                                                            setCertificates(temp);
                                                        } }>+ Add more</a>
                                                    </div>
                                                </>
                                            ) }

                                            <div className="col-12 mt-3">
                                                <button className="btn btn-primary w-100 py-3"
                                                    type="submit"
                                                    disabled={ updatingProfile }>Update</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            ) : pageType == "payments" ? (
                                <>
                                    <table className="table table-bordered table-responsive">
                                        <thead>
                                            <tr>
                                                <th>Method</th>
                                                <th>Status</th>
                                                <th>Amount</th>
                                                <th>Payment for</th>
                                                <th>Date & time</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            { payments.map(function (payment) {
                                                return (
                                                    <tr key={ `payment-${ payment.id }` }>
                                                        <td>
                                                            { payment.method == "stripe" && payment.payment_obj != null ? (
                                                                <a href={ `https://dashboard.stripe.com/test/payments/${ payment.payment_obj.id }` }
                                                                    target="_blank">{ payment.method.toUpperCase() }</a>
                                                            ) : (
                                                                <>
                                                                    { payment.method.toUpperCase() }
                                                                </>
                                                            ) }
                                                        </td>

                                                        <td>{ payment.status }</td>

                                                        <td>
                                                            { payment.method == "stripe" ? (
                                                                <>
                                                                    ${ payment.amount / 100 }
                                                                </>
                                                            ) : (
                                                                <>
                                                                    ${ payment.amount }
                                                                </>
                                                            ) }
                                                        </td>

                                                        <td>
                                                            { payment.job != null ? (
                                                                <>
                                                                    Job: <Link to={ `/jobs/${ payment.job.id }` }>{ payment.job.title }</Link>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    { payment.table_id }
                                                                </>
                                                            ) }
                                                        </td>

                                                        <td>{ payment.created_at }</td>
                                                    </tr>
                                                );
                                            }) }
                                        </tbody>
                                    </table>

                                    { fetchingPayments && (
                                        <div className="row">
                                            <div className="col-md-12 text-center">
                                                <Loader />
                                            </div>
                                        </div>
                                    ) }

                                    { paymentsPages > 1 && (
                                        <nav>
                                            <ul className="pagination">
                                                { Array.from({ length: paymentsPages }, function (_, index) { return index + 1 } ).map(function (p) {
                                                    return (
                                                        <li key={ `pagination-${ p }` } className={ `page-item ${ p == paymentsPage ? "active" : "" }` }>
                                                            <a href="#" onClick={ function (event) {
                                                                event.preventDefault();
                                                                setPaymentsPage(p);
                                                                setRefetchPayments(refetchPayments + 1);
                                                            } } className="page-link">{ p }</a>
                                                        </li>
                                                    );
                                                }) }
                                            </ul>
                                        </nav>
                                    ) }
                                </>
                            ) : pageType == "receipts" ? (
                                <>
                                    <table className="table table-bordered table-responsive">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Type</th>
                                                <th>Receipt for</th>
                                                <th>Date & time</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            { receipts.map(function (receipt) {
                                                return (
                                                    <tr key={ `receipt-${ receipt.id }` }>
                                                        <td>
                                                            <a href={ receipt.path }
                                                                target="_blank">#{ receipt.id }</a>
                                                        </td>

                                                        <td className="text-capitalize">{ receipt.type.split("_").join(" ") }</td>

                                                        <td>
                                                            { receipt.job != null ? (
                                                                <>
                                                                    Job: <Link to={ `/jobs/${ receipt.job.id }` }>{ receipt.job.title }</Link>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    { receipt.table_id }
                                                                </>
                                                            ) }
                                                        </td>

                                                        <td>{ receipt.created_at }</td>
                                                    </tr>
                                                );
                                            }) }
                                        </tbody>
                                    </table>

                                    { fetchingReceipts && (
                                        <div className="row">
                                            <div className="col-md-12 text-center">
                                                <Loader />
                                            </div>
                                        </div>
                                    ) }

                                    { receiptsPages > 1 && (
                                        <nav>
                                            <ul className="pagination">
                                                { Array.from({ length: receiptsPages }, function (_, index) { return index + 1 } ).map(function (p) {
                                                    return (
                                                        <li key={ `pagination-${ p }` } className={ `page-item ${ p == receiptsPage ? "active" : "" }` }>
                                                            <a href="#" onClick={ function (event) {
                                                                event.preventDefault();
                                                                setReceiptsPage(p);
                                                                setRefetchReceipts(refetchReceipts + 1);
                                                            } } className="page-link">{ p }</a>
                                                        </li>
                                                    );
                                                }) }
                                            </ul>
                                        </nav>
                                    ) }
                                </>
                            ) : pageType == "change-password" && (
                                <>
                                    <form onSubmit={ function (event) {
                                        event.preventDefault();
                                        changePassword();
                                    } } id="form-change-password">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-floating">
                                                    <input type="password" className="form-control" name="current_password" placeholder="Current password" />
                                                    <label>Current password</label>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-floating">
                                                    <input type="password" className="form-control" name="new_password" placeholder="New password" />
                                                    <label>New password</label>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-floating">
                                                    <input type="password" className="form-control" name="confirm_password" placeholder="Confirm password" />
                                                    <label>Confirm password</label>
                                                </div>
                                            </div>

                                            <div className="col-md-12 mt-3">
                                                <button className="btn btn-primary w-100 py-3" type="submit"
                                                    disabled={ changingPassword }>Change password</button>
                                            </div>
                                        </div>
                                    </form>
                                </>
                            ) }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Profile;